<fury-page>
    <fury-title class="title">
        <h2>{{!categoryId ? 'Add' : 'Update'}} Homeowner Category</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="categoryForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <div>
              <h4>Category Info</h4>
            </div>
            <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
            style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
            <div class="flex">
              <div class="innerdiv">
                <div class="uploadsec">
                  <div class="imgsec">
                    <img [src]="imagestoupload ?  imagestoupload : '../../../../../assets/img/no_thumbnail.jpg'" alt="">
                  </div>
                  <div class="uploadbtnsec">
                    <input type="file" #galleryImage (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                      style="display:none">
                    <button type="button" class="uploadfilebtn" mat-raised-button (click)="galleryImage.click()">Upload a File</button>
                  </div>
                </div>
              </div>
               
            </div>
            </fxLayout>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Alt Text</mat-label>
              <input matInput placeholder="Alt Text" formControlName="bannerImageAlternateText">
              <mat-error
                *ngIf="categoryForm.controls['bannerImageAlternateText'].touched && categoryForm.controls['bannerImageAlternateText'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
       
        
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title" (keyup)="apiService.restrictChar($event, 255)" formControlName="title">
              <mat-error
                *ngIf="categoryForm.controls['title'].touched && categoryForm.controls['title'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Meta Title</mat-label>
              <input matInput placeholder="Meta Title" (keyup)="apiService.restrictChar($event, 255)" formControlName="metaTitle">
              <mat-error
                *ngIf="categoryForm.controls['metaTitle'].touched && categoryForm.controls['metaTitle'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Meta Description</mat-label>
              <input matInput placeholder="Meta Description" (keyup)="apiService.restrictChar($event, 155)" formControlName="metaDescription">
              <mat-error
                *ngIf="categoryForm.controls['metaDescription'].touched && categoryForm.controls['metaDescription'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput placeholder="Description" formControlName="description"></textarea>
              <mat-error
                *ngIf="categoryForm.controls['description'].touched && categoryForm.controls['description'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
          </div>
            
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button"
            (click)="submit()"><span>{{!categoryId ? 'Add' : 'Update'}}</span></button>
            <button mat-button type="button" class="can-button" (click)="back()"><span>Cancel</span></button>
          </div>
             
             
            <!-- <div class="form-fld text-center">
              <div class="actionControl">
                <button type="button" class="submit-btn" (click)="submit()"><span>{{!categoryId ? 'Add' : 'Update'}}</span></button>
              </div>
            </div> -->
          </form>
    </div>
  </div>
